import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_ordering_mode.js";
//#region src/kiosk_ordering_mode_helper.ts
var kiosk_ordering_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "full": return "Full Ordering";
		case "scanner-only": return "Scanner Only Ordering";
	}
}
//#endregion
export { kiosk_ordering_mode_helper_exports, name };

//# sourceMappingURL=kiosk_ordering_mode_helper.js.map